/**
 * Utility functions to remove search_tool tags and their content from text
 */

/**
 * Removes all <search_tool>...</search_tool> tags and their content from the given string
 */
export const removeSearchToolTags = (content: string): string => {
  if (!content || typeof content !== 'string') return content;

  const searchToolRegex = /<search_tool\b[^>]*>[\s\S]*?<\/search_tool>/gi;

  return content.replace(searchToolRegex, '').trim();
};

/**
 * Recursively cleans search_tool tags from nested content structures
 */
export const cleanSearchToolTagsFromStructure = (obj: any): any => {
  if (!obj) return obj;

  if (typeof obj === 'string') {
    return removeSearchToolTags(obj);
  }

  if (Array.isArray(obj)) {
    return obj.map(cleanSearchToolTagsFromStructure);
  }

  if (typeof obj === 'object') {
    const cleaned: any = {};
    for (const [key, value] of Object.entries(obj)) {
      if (
        key === 'Content' ||
        key === 'content' ||
        key === 'OverviewContent' ||
        key === 'description' ||
        key === 'Description'
      ) {
        cleaned[key] = removeSearchToolTags(value as string);
      } else {
        cleaned[key] = cleanSearchToolTagsFromStructure(value);
      }
    }
    return cleaned;
  }

  return obj;
};
